import React from 'react';
import styled from 'styled-components';
import Tooltip from '@catalogo/ui-americanas-mobile-product-tooltip';
import Info from '@catalogo/ui-americanas-desktop-svg/icon-info.svg';
import { formatPrice } from '@catalogo/core-helpers/price';
import { withDevice } from '@catalogo/core-connect/device';
import { TDiscountProgressive } from './interfaces';

export const DiscountProgressive: TDiscountProgressive = ({
  device,
  quantityForDiscount,
  priceUnit,
  discountProgressiveExperiment,
}) => {
  if (!quantityForDiscount || !priceUnit || discountProgressiveExperiment !== 'NEW') {
    return null;
  }

  const isMobile = device == 'mobile';

  const tooltipProps = {
    boxMarginLeft: isMobile ? '-10px' : '0px',
    arrowMarginLeft: isMobile ? '277px' : '268px',
    nodeElementCloseOnClick: 'svg',
    tooltipSizeDesk: '305px',
    tooltipDistanceTop: '-86px',
    tooltipDistanceBottom: '16px',
    startOpen: false,
    openTooltipWith: ['svg', 'path'],
  };

  return (
    <Container>
      <Tooltip {...tooltipProps}>
        <Badge>
          <Text>
            a partir de
            <b>
              &nbsp;{quantityForDiscount} unidades pague R$ {formatPrice(priceUnit)}&nbsp;
            </b>
            cada
          </Text>
          <IconInfo />
        </Badge>
        <TooltipText>
          Caso tenha um desconto maior levando mais unidades do produto, a gente te informa na cesta :)
        </TooltipText>
      </Tooltip>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  display: flex;
  margin-top: 8px;
  padding: 7px 0px;
  border-radius: 4px;
  justify-content: center;
  background-color: #d9ffd9;
`;

const Badge = styled.div`
  display: flex;
  align-items: center;
`;

const Text = styled.p`
  font-size: 14px;
  color: #004800;
`;

const IconInfo = styled(Info)`
  width: 16px;
  height: 16px;
  margin-left: 8px;
  fill: ${({ theme }) => theme.grey.darker};
`;

const TooltipText = styled.p`
  font-size: 12px;
  color: ${({ theme }) => theme.grey.darker};
`;

export default withDevice(DiscountProgressive);
